export interface WebRuntimeConfig {
  readonly apiBaseUrl: string;
  readonly gameWebSocketUrl: string;
}

function withoutTrailingSlash(value: string): string {
  return value.replace(/\/+$/u, '');
}

export function runtimeConfig(location: Pick<Location, 'protocol' | 'host'>): WebRuntimeConfig {
  const configuredApi = import.meta.env.VITE_API_BASE_URL as string | undefined;
  const configuredSocket = import.meta.env.VITE_GAME_WEBSOCKET_URL as string | undefined;
  const socketProtocol = location.protocol === 'https:' ? 'wss:' : 'ws:';

  return Object.freeze({
    apiBaseUrl: withoutTrailingSlash(configuredApi?.trim() || '/api/v1'),
    gameWebSocketUrl: withoutTrailingSlash(
      configuredSocket?.trim() || `${socketProtocol}//${location.host}/ws/v1/games`,
    ),
  });
}
